import { render, staticRenderFns } from "./AutorizarMovimiento.vue?vue&type=template&id=1d649975&scoped=true"
import script from "./AutorizarMovimiento.vue?vue&type=script&lang=js"
export * from "./AutorizarMovimiento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d649975",
  null
  
)

export default component.exports